import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-reset-pass-confirmation',
  templateUrl: './reset-pass-confirmation.component.html',
  styleUrls: ['./reset-pass-confirmation.component.scss']
})
export class ResetPassConfirmationComponent implements OnInit {

  selectedUser: string = this.data.selectedUser;
  fieldTextType2: boolean = true;
  fieldTextType: boolean = true;
  resetPassForm: UntypedFormGroup;
  errorMsg: string=  null;

  constructor(
    public dialog: MatDialogRef<ResetPassConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedUser: string; loggedInUser: string },
    private userService: UserService,
    private snackBar: MatSnackBar, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.createResetForm();
  }

  createResetForm(){
    this.resetPassForm = new UntypedFormGroup({
      newPass: new UntypedFormControl('', [Validators.required]),
      confirmNewPass: new UntypedFormControl('', [Validators.required])
    })
  }
  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  // Prevent keyboard shortcuts (Ctrl+V, etc)
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const ctrlKeys = ['v', 'V', 'c', 'C', 'x', 'X'];
    if ((event.ctrlKey || event.metaKey) && ctrlKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onSubmit(){
    if (!this.resetPassForm.valid) {
      this.resetPassForm.markAllAsTouched();
      return;
    }
    if(!this.resetPassForm.value.newPass.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)) {
      this.errorMsg = "Password must be of minimum 8 character containing at least one uppercase, one lowercase, one digit, one special character( _ @ $ )"
      return;
    }
    if (this.resetPassForm.value.newPass != this.resetPassForm.value.confirmNewPass) {
      this.errorMsg = "New password and confirm password does not match."
      return;
    }
    this.spinner.show();
    this.userService
    .changeUserPassword(this.selectedUser, this.resetPassForm.value.newPass)
    .subscribe({
      next: (data: any) => {
        this.snackBar.open(data.message, 'Ok', {
          duration: 5000
        });
        this.errorMsg = null;
        this.dialog.close();
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        this.snackBar.open(err.error, 'Ok', {
          duration: 5000
        });
      }
    })
  }

  onClose(){
    this.dialog.close();
  }

  togglePassswordIcon(fieldNum: number) {
    if (fieldNum == 1) {
      this.fieldTextType = !this.fieldTextType;
    } else {
      this.fieldTextType2 = !this.fieldTextType2;
    }
  }

}
